__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "branding-studio-webapp";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@ant-design/colors", "6.0.0", () => (__webpack_require__.e(680).then(() => (() => (__webpack_require__(72680))))));
			register("@ant-design/colors", "6.0.0", () => (__webpack_require__.e(733).then(() => (() => (__webpack_require__(73733))))));
			register("@nackle/biw-web-router", "1.3.3", () => (Promise.all([__webpack_require__.e(899), __webpack_require__.e(569)]).then(() => (() => (__webpack_require__(33899))))));
			register("@nackle/bridge", "2.7.3", () => (Promise.all([__webpack_require__.e(9), __webpack_require__.e(169)]).then(() => (() => (__webpack_require__(41009))))));
			register("@nackle/intl-tools", "1.4.21", () => (Promise.all([__webpack_require__.e(446), __webpack_require__.e(255), __webpack_require__.e(985)]).then(() => (() => (__webpack_require__(53167))))));
			register("@nackle/menu", "1.2.9", () => (Promise.all([__webpack_require__.e(335), __webpack_require__.e(627), __webpack_require__.e(259), __webpack_require__.e(190)]).then(() => (() => (__webpack_require__(40190))))));
			register("@nackle/paper", "2.9.1", () => (Promise.all([__webpack_require__.e(249), __webpack_require__.e(446), __webpack_require__.e(353), __webpack_require__.e(49), __webpack_require__.e(434)]).then(() => (() => (__webpack_require__(61329))))));
			register("@nackle/studio-tools", "1.8.6", () => (Promise.all([__webpack_require__.e(249), __webpack_require__.e(966), __webpack_require__.e(49), __webpack_require__.e(335), __webpack_require__.e(227), __webpack_require__.e(13)]).then(() => (() => (__webpack_require__(49966))))));
			register("lodash-es", "4.17.21", () => (__webpack_require__.e(503).then(() => (() => (__webpack_require__(54503))))));
			register("react-dom", "17.0.2", () => (() => (__webpack_require__(73935))), 1);
			register("react", "17.0.2", () => (() => (__webpack_require__(67294))), 1);
			initExternal(6091);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};